import React from "react";
import { Navigate, useParams } from "react-router-dom";

function TournamentScoreRedirect() {
  const { tournamentId } = useParams<{ tournamentId: string }>();

  if (!tournamentId) {
    return <Navigate to="/admin/tournaments" replace />;
  }

  return <Navigate to={`/admin/tournaments/${tournamentId}?tab=scores`} replace />;
}

export default TournamentScoreRedirect;
